<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
>
  <div
    class="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 animate-fade-in"
  >
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-semibold text-gray-800">Actualizar correo</h2>
      <button
        (click)="closeModal()"
        class="text-gray-400 hover:text-gray-600 transition"
      >
        ✕
      </button>
    </div>
    <div class="mb-3">
      <p class="text-sm text-gray-600">
        Tu correo actual:
        <span class="font-medium text-gray-800">{{ currentEmail }}</span>
      </p>
    </div>
    <form [formGroup]="formEmail" (ngSubmit)="sendCode()" class="space-y-4">
      <div>
        <label for="email" class="block text-sm font-medium text-gray-700"
          >Nuevo correo electrónico</label
        >
        <input
          type="email"
          id="email"
          formControlName="email"
          class="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
          placeholder="ejemplo@correo.com"
        />
        <div
          *ngIf="formEmail.get('email')?.invalid && formEmail.get('email')?.touched"
          class="text-sm text-red-500 mt-1"
        >
          Ingresa un correo válido.
        </div>
      </div>
      <div class="flex justify-end gap-2 pt-3">
        <button
          type="button"
          (click)="closeModal()"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
        >
          Cancelar
        </button>
        <app-loading-button [type]="'submit'" [loading]="isLoading" [text]="'Guardar'"></app-loading-button>
      </div>
    </form>
  </div>
</div>
